import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import { PlatformClient } from '../httpClients/PlatformClient/PlatformClient';
import { QUERY_KEYS } from '../queries/consts';
import { queryClient } from '../queryClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useDeleteSelfMutation = () => {
  const spawnToasts = spawn('toasts.account.delete-self');

  return useMutation({
    mutationKey: [MUTATION_KEYS.DELETE_SELF],
    mutationFn: async () => {
      return await PlatformClient.deleteSelf();
    },
    onSuccess: () => {
      toast.success(spawnToasts('success'));
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USER],
      });
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
